module.exports = __webpack_public_path__ + "img/1f939.54dbb838.svg";